import React from "react";

const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        id="Path_392"
        fill="#006747"
        d="M10.722,3.199c1.996-0.006,3.911,0.786,5.32,2.2c1.414,1.408,2.206,3.324,2.2,5.32
      c0.002,0.877-0.151,1.748-0.45,2.572c-0.29,0.795-0.712,1.535-1.248,2.189l-0.5,0.606l-0.612,0.494c-1.333,1.083-3,1.67-4.718,1.663
      c-1.996,0.006-3.911-0.786-5.32-2.2c-1.414-1.408-2.206-3.324-2.2-5.32c-0.006-1.996,0.786-3.912,2.2-5.32
      c1.408-1.414,3.324-2.206,5.32-2.2 M10.714,0.003C4.798,0.009,0.005,4.806,0.003,10.722c0,5.922,4.8,10.722,10.722,10.722l0,0
      c2.448,0.004,4.822-0.834,6.726-2.372c-0.225,0.792-0.005,1.644,0.576,2.227l4.038,4.038c0.426,0.425,1.003,0.663,1.605,0.662
      c0.6,0,1.176-0.238,1.6-0.662l0,0c0.882-0.888,0.882-2.322,0-3.21l-4.038-4.038c-0.424-0.424-1-0.662-1.6-0.662
      c-0.205,0-0.408,0.027-0.606,0.081c1.569-1.913,2.426-4.312,2.422-6.787c0-5.922-4.8-10.722-10.722-10.722l0,0L10.714,0.003z"
      />
    </svg>
  );
};

export default SearchIcon;
